import { FC } from 'react'

import { ButtonGradient } from 'components/ButtonGradient'
import { useCommonConnectStore } from 'components/WalletProvider/store'
import { cx } from 'utils/cx'

type Props = {
  className?: string
  disabled?: boolean
  onClick: () => void
  title?: string
}

const ButtonConnectWallet: FC<Props> = ({ className, disabled, onClick, title }) => {
  const claimWidgetClasses = useCommonConnectStore((state) => state.claimWidgetClasses)

  return (
    <ButtonGradient
      className={cx(claimWidgetClasses.connectWalletButton, className)}
      disabled={disabled}
      onClick={onClick}
    >
      {title || 'Connect Wallet'}
    </ButtonGradient>
  )
}

export default ButtonConnectWallet
